import React from 'react';
import FlexWrapper from 'ui/FlexWrapper';
import Headline from 'ui/Headline';
import Text from 'ui/Text';

import { COLORS } from 'themes/';
import axios from 'axios';

class VideoPlayer extends React.Component {
    state = {
        fastTrackUrl: '',
    };

    componentDidMount() {
        this.props.enableCloseButton(null, COLORS.grey);

        axios
            .post('/heste/media/fasttrack/getUrl')
            .then(({ data }) => {
                data.success && this.setState({ fastTrackUrl: data.data });
            })
            .catch(() => console.warn('Can not fetch fast track URL'));
    }

    render() {
        const data = this.props.modalData;

        return (
            <FlexWrapper black align="center" margin="0px" padding="0px">
                <Headline margin="0px" padding="10px" align="center">
                    {data.title}
                </Headline>
                <Text padding="10px 10px 30px" align="center">
                    {data.description}
                </Text>

                <iframe
                    width="100%"
                    id="video-iframe"
                    style={{ border: '0px' }}
                    height="400px"
                    title="video-iframe"
                    allowFullScreen
                    src={
                        data.dk
                            ? this.state.fastTrackUrl
                            : 'https://www.atgvision.com/hlsplayer/bet25/'
                    }
                />
            </FlexWrapper>
        );
    }
}

export default VideoPlayer;
